import styled from "@emotion/styled";
import { DeleteOutline } from "@mui/icons-material";
import { Modal, Stack, Typography } from "@mui/material";
import { useChurchStore } from "features/churches";
import { useTranslation } from "react-i18next";
import { useDeleteTeamType } from "../api";
import { useTeamsStore } from "../stores";

const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 280px;
  // height: 200px;
  max-width: 100%;
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-block: 12px;
  background-color: #eeeeee;
  color: #f44949;
  font-size: 12px;
`;

const Content = styled(Stack)`
  padding-block: 30px;
  text-align: center;
`;

const DeleteButton = styled.button`
  background-color: #f44949;
  border: none;
  outline: none;
  padding: 5px 10px;
  color: #ffffff;
  font-weight: 700;
  border-radius: 2px;
  cursor: pointer;
`;

const CancelButton = styled.button`
  background-color: #eeeeee;
  border: none;
  outline: none;
  padding: 5px 10px;
  color: #000000;
  font-weight: 700;
  border-radius: 2px;
  cursor: pointer;
`;

export const DeleteTeamTypeNote = ({ name }) => {
  const deleteTeamTypeModalOpen = useTeamsStore(
    state => state.deleteTeamTypeModalOpen
  );
  const closeDeleteTeamTypeModal = useTeamsStore(
    state => state.closeDeleteTeamTypeModal
  );
  const deleteMutation = useDeleteTeamType();
  const currentTeamType = useTeamsStore(state => state.currentTeamType);
  const selectedChurch = useChurchStore(state => state.selectedChurch);
  const { t } = useTranslation();

  const deleteTeamType = () => {
    deleteMutation.mutate({
      churchId: selectedChurch?.id,
      teamTypeId: currentTeamType?.id
    });
  };

  return (
    <Modal open={deleteTeamTypeModalOpen} onClose={closeDeleteTeamTypeModal}>
      <Container>
        <Header>
          <DeleteOutline />
          <span>{t("teams.deleteTeam.DeleteNote")}</span>
        </Header>
        <Content spacing={2} alignItems="center">
          <Typography variant="caption" sx={{ color: "#4D4D4D" }}>
            This will delete {name} team type permanently.
            <br /> Are you sure to delete?
          </Typography>
          <Stack direction="row" spacing={2}>
            <CancelButton onClick={closeDeleteTeamTypeModal}>
              {t("teams.deleteTeam.NoKeepIt")}
            </CancelButton>
            <DeleteButton onClick={deleteTeamType}>
              {t("teams.deleteTeam.YesDelete")}
            </DeleteButton>
          </Stack>
        </Content>
      </Container>
    </Modal>
  );
};
